import { useSelector } from 'react-redux'
import { selectInvalidStructure } from '../../StockAdjustmentInBatchSeletor'
import * as S from './InvalidStructureTable.styles'

export default () => {
  const invalidStructure = useSelector(selectInvalidStructure)

  if (!invalidStructure?.missingColumns || invalidStructure.missingColumns.length === 0) {
    return null
  }

  return (
    <S.Wrapper>
      <S.Title>Colunas Faltando na Tabela</S.Title>
      <S.List>
        {invalidStructure?.missingColumns?.map((columnName) => (
          <S.Item key={columnName} >{columnName}</S.Item>
        ))}
      </S.List>
    </S.Wrapper>
  )
}
